import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import createCustomSchema from "../../fieldValidator/fieldValidator";
import toast from "react-hot-toast";
import { companyID } from "../../auth";
import Loader from "../Loader";
import FilePreviewer from "../FilePreviewer";
import { uploadDocumentsData } from "../../services/uploadDocumentService";

const validationSchema = Yup.object({
  document_type: createCustomSchema("dropdown", {
    message: "* Select Document Type!",
  }),
  document: createCustomSchema("file", {
    message: "* Select Document!",
  }),
  employee_id: createCustomSchema("dropdown", {
    message: "* Select Employee!",
  }),
});

const UploadDocuments = ({
  fetchRequestedDocument,
  show,
  handleClose,
  employeeData,
  employerDocuments,
}) => {
  const [formData, setFormData] = useState({
    document_type: "",
    document: null,
    employee_id: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = async (e) => {
    const { name, value, files } = e.target;
    const fieldValue = files ? files[0] : value;
    setFormData((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));
    try {
      await validationSchema.validateAt(name, {
        ...formData,
        [name]: fieldValue,
      });
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    } catch (err) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: err.message,
      }));
    }
  };

  const handleSubmit = async () => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });
      setErrors({});
      setLoading(true);

      const documentData = new FormData();
      documentData.append("document_type", formData.document_type);
      documentData.append("document", formData.document);
      documentData.append("employee_id", formData.employee_id);
      documentData.append("created_by", localStorage.getItem("employeeID"));

      const response = await uploadDocumentsData(documentData);
      console.log("response", response);

      toast.success("Document uploaded successfully!");
      fetchRequestedDocument();
      handleClose();
    } catch (err) {
      const newErrors = {};
      if (err.inner) {
        err.inner.forEach((e) => {
          newErrors[e.path] = e.message;
        });
        setErrors(newErrors);
      }
    } finally {
      setLoading(false);
    }
  };

  console.log("formData", formData);

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Upload Documents</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={(e) => e.preventDefault()}>
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Select Employee</Form.Label>
                <Form.Select
                  name="employee_id"
                  value={formData.employee_id}
                  onChange={handleChange}
                >
                  <option value="">-- Select --</option>
                  {employeeData?.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp?.first_name} {emp?.middle_name || ""}{" "}
                      {emp?.last_name || ""}{" "}
                      {emp?.employment_id ? ` - ${emp?.employment_id} ` : ""}
                    </option>
                  ))}
                </Form.Select>
                <small className="text-danger">{errors.employee_id}</small>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Select Document </Form.Label>
                <Form.Select
                  name="document_type"
                  value={formData.document_type}
                  onChange={handleChange}
                >
                  <option value="">-- Select --</option>
                  {employerDocuments?.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.document}
                    </option>
                  ))}
                </Form.Select>
                <small className="text-danger">{errors.document_type}</small>
              </Form.Group>
            </Col>

            <Col md={6} className="mt-3">
              <Form.Group>
                <Form.Label>Upload Document</Form.Label>
                <Form.Control
                  type="file"
                  name="document"
                  onChange={handleChange}
                />
                <div className="upload_image_file_status">
                  *Uploaded File must be pdf or 500KB less
                </div>
                <small className="text-danger">{errors.document}</small>
              </Form.Group>
            </Col>

            {formData?.document && (
              <FilePreviewer fileSource={formData?.document} />
            )}
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} className="me-2">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadDocuments;
